/**
 * Bouton « Copier » générique — même recette que `ApiKeysPanel::copyToken` et
 * `DnsRecords::CopyValue` (état local `copied`, repli silencieux si le presse-papiers refuse),
 * extraite ici pour que `McpHelpPanel` et la modale de création d'`ApiKeysPanel` ne la
 * réécrivent pas une troisième fois.
 */

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BTN_GHOST_SM } from '../ui/theme.js';

export function CopyButton({ value, className = '' }) {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
    } catch {
      setCopied(false);
    }
  };

  return (
    <button type="button" className={`${BTN_GHOST_SM} ${className}`} onClick={copy}>
      {copied ? t('common.copied') : t('common.copy')}
    </button>
  );
}
